// import React from 'react';
// import { Box, Typography, Link, Stack, useTheme, useMediaQuery } from '@mui/material';
// import addressIcon from '../assets/yelloloc.png'; // replace with your uploaded icon
// import contactIcon from '../assets/yelloinpho.png'; // your combined email + phone icon
// import combinedLogo from '../assets/pdt-logo-white 1.png'; 

// const Footer = () => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

//   return (
//     <Box
//       id="footer-section"
//       component="footer"
//       sx={{
//         backgroundColor: '#0d111c',
//         color: '#CBD5E1',
//         display: 'flex',
//         flexDirection: isMobile ? 'column' : 'row',
//         flexWrap: 'wrap',
//         justifyContent: 'space-between',
//         padding: isMobile ? '30px 20px' : '40px 30px',
//         fontFamily: 'Outfit',
//       }}
//     >
//       {/* Left Logo & About */}
//       <Box sx={{ flex: '1 1 25%', mb: isMobile ? 3 : 0 }}>
//         <Stack direction="column" spacing={2}>
//           <Box>
//             <img
//               src={combinedLogo}
//               alt="Property Deals Talk Logo"
//               style={{
//                 width: isMobile ? 140 : 190,
//                 height: 'auto',
//                 objectFit: 'contain',
//               }}
//             />
//           </Box>
//           <Typography
//             sx={{
//               fontSize: 16,
//               fontWeight: 400,
//               lineHeight: 1.4,
//               color: '#CBD5E1',
//               marginTop: '5px',
//             }}
//           >
//             A great platform to buy, sell and rent your properties without any agent or commissions.
//           </Typography>
//         </Stack>
//       </Box>
//       {/* Middle Links */}
//       {/* Middle Links */}
//       <Box
//         sx={{
//           display: 'flex',
//           flex: '1 1 50%',
//           flexDirection: isMobile ? 'row' : 'row', // ✅ stay side by side on mobile
//           flexWrap: 'wrap',
//           justifyContent: 'space-between', // ✅ force space between on both
//           columnGap: isMobile ? 0 : '60px',
//           rowGap: isMobile ? 0 : '24px',
//           mb: isMobile ? 3 : 0,
//         }}
//       >
//         {/* Information Links */}
//         <Box sx={{ flex: '1 1 auto', minWidth: 140, ml: isMobile ? 0 : 14 }}>
//           <Typography variant="h6" sx={{ mb: 1, fontWeight: 600, color: '#FFFFFF' }}>
//             Information Links
//           </Typography>
//           <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
//             {['Terms & Conditions', 'Privacy Policy', 'Contact'].map((text, i) => (
//               <li key={i} style={{ marginBottom: 6 }}>
//                 <Link href="#" underline="none" sx={{ color: '#CBD5E1', fontWeight: 400 }}>
//                   {text}
//                 </Link>
//               </li>
//             ))}
//           </ul>
//         </Box>
//         {/* Useful Links */}
//         <Box
//           sx={{
//             flex: '1 1 auto',
//             minWidth: 140,
//             ml: isMobile ? 0 : 'auto',
//             mr: isMobile ? 0 : 11,
//           }}
//         >
//           <Typography variant="h6" sx={{ mb: 1, fontWeight: 600, color: '#FFFFFF' }}>
//             Useful Links
//           </Typography>
//           <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
//             {['About Us', 'Services', 'Login'].map((text, i) => (
//               <li key={i} style={{ marginBottom: 6 }}>
//                 <Link href="#" underline="none" sx={{ color: '#CBD5E1', fontWeight: 400 }}>
//                   {text}
//                 </Link>
//               </li>
//             ))}
//           </ul>
//         </Box>
//       </Box>
//       {/* Contact Details */}
//       <Box
//         sx={{
//           flex: '1 1 25%',
//           textAlign: isMobile ? 'center' : 'left',
//         }}
//       >
//         <Typography variant="h6" sx={{ mb: 1, fontWeight: 600, color: '#FFFFFF' }}>
//           Contact Details
//         </Typography>
//         <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
//           <li style={{ marginBottom: 10 }}>
//             <Stack direction="row" alignItems="center" justifyContent={isMobile ? 'center' : 'flex-start'}>
//               <Box component="img" src={addressIcon} alt="address" sx={{ width: 16, height: 16, mr: 1 }} />
//               <Typography sx={{ fontSize: 17, fontWeight: 400, color: '#CBD5E1' }}>
//                 Kukatpally, Hyderabad, Telangana - 72
//               </Typography>
//             </Stack>
//           </li>
//           <li style={{ marginBottom: 10 }}>
//             <Link href="#" underline="none" sx={{ color: '#FF9900', fontWeight: 500, fontSize: 17 }}>
//               View on Google map
//             </Link>
//           </li>
//           <li>
//             <Stack direction="row" alignItems="center" justifyContent={isMobile ? 'center' : 'flex-start'}>
//               <Box
//                 component="img"
//                 src={contactIcon}
//                 alt="contact"
//                 sx={{ width: 18, height: 57, mr: 1.5 }}
//               />
//               <Box>
//                 <Typography sx={{ fontSize: 17, fontWeight: 400, color: '#CBD5E1' }}>
//                   <Link 
//                     href="mailto:propertydealstalk@gmail.com" 
//                     underline="none" 
//                     sx={{ color: '#CBD5E1', '&:hover': { color: '#FF9900' } }}
//                   >
//                     propertydealstalk@gmail.com
//                   </Link>
//                 </Typography>
//                 <Typography sx={{ fontSize: 17, fontWeight: 400, color: '#CBD5E1' }}>
//                   <Link 
//                     href="tel:+919346799389" 
//                     underline="none" 
//                     sx={{ color: '#CBD5E1', '&:hover': { color: '#FF9900' } }}
//                   >
//                     +91 93467 99389
//                   </Link>
//                 </Typography>
//                  <Typography sx={{ fontSize: 17, fontWeight: 400, color: '#CBD5E1' }}>
//                   <Link 
//                     href="tel:+917780251777" 
//                     underline="none" 
//                     sx={{ color: '#CBD5E1', '&:hover': { color: '#FF9900' } }}
//                   >
//                     +91 77802 51777
//                   </Link>
//                 </Typography>
//               </Box>
//             </Stack>
//           </li>
//         </ul>
//       </Box>
//     </Box>
//   );
// };

// export default Footer;



import React, { useEffect, useState } from 'react';
import { Box, Typography, Link, Stack, useTheme, useMediaQuery, Fade } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import addressIcon from '../assets/yelloloc.png';
import contactIcon from '../assets/yelloinpho.png';
import combinedLogo from '../assets/pdt-logo-white 1.png';

const Footer = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [highlight, setHighlight] = useState(false);

  useEffect(() => {
    const handleHighlight = () => {
      setHighlight(true);
      setTimeout(() => setHighlight(false), 4000); // Remove highlight after 4 seconds
    };

    window.addEventListener('highlightContact', handleHighlight);
    return () => window.removeEventListener('highlightContact', handleHighlight);
  }, []);

  return (
    <Box
      id="footer-section"
      component="footer"
      sx={{
        backgroundColor: '#0d111c',
        color: '#CBD5E1',
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        padding: isMobile ? '30px 20px' : '40px 30px',
        fontFamily: 'Outfit',
        position: 'relative',
      }}
    >
      {/* Left Logo & About */}
      <Box sx={{ flex: '1 1 25%', mb: isMobile ? 3 : 0 }}>
        <Stack direction="column" spacing={2}>
          <Box>
            <img
              src={combinedLogo}
              alt="Property Deals Talk Logo"
              style={{
                width: isMobile ? 140 : 190,
                height: 'auto',
                objectFit: 'contain',
              }}
            />
          </Box>
          <Typography
            sx={{
              fontSize: 16,
              fontWeight: 400,
              lineHeight: 1.4,
              color: '#CBD5E1',
              marginTop: '5px',
            }}
          >
            A great platform to buy, sell and rent your properties without any agent or commissions.
          </Typography>
        </Stack>
      </Box>

      {/* Middle Links */}
      <Box
        sx={{
          display: 'flex',
          flex: '1 1 50%',
          flexDirection: isMobile ? 'row' : 'row',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          columnGap: isMobile ? 0 : '60px',
          rowGap: isMobile ? 0 : '24px',
          mb: isMobile ? 3 : 0,
        }}
      >
        {/* Information Links */}
        <Box sx={{ flex: '1 1 auto', minWidth: 140, ml: isMobile ? 0 : 14 }}>
          <Typography variant="h6" sx={{ mb: 1, fontWeight: 600, color: '#FFFFFF' }}>
            Information Links
          </Typography>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            {['Terms & Conditions', 'Privacy Policy', 'Contact'].map((text, i) => (
              <li key={i} style={{ marginBottom: 6 }}>
                <Link href="#" underline="none" sx={{ color: '#CBD5E1', fontWeight: 400 }}>
                  {text}
                </Link>
              </li>
            ))}
          </ul>
        </Box>

        {/* Useful Links */}
        <Box
          sx={{
            flex: '1 1 auto',
            minWidth: 140,
            ml: isMobile ? 0 : 'auto',
            mr: isMobile ? 0 : 11,
          }}
        >
          <Typography variant="h6" sx={{ mb: 1, fontWeight: 600, color: '#FFFFFF' }}>
            Useful Links
          </Typography>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            {['About Us', 'Services', 'Login'].map((text, i) => (
              <li key={i} style={{ marginBottom: 6 }}>
                <Link href="#" underline="none" sx={{ color: '#CBD5E1', fontWeight: 400 }}>
                  {text}
                </Link>
              </li>
            ))}
          </ul>
        </Box>
      </Box>

      {/* Contact Details - WITH MUI ICON POINTER */}
      <Box
        id="contact-details"
        sx={{
          flex: '1 1 25%',
          textAlign: isMobile ? 'center' : 'left',
          padding: '20px',
          borderRadius: '8px',
          position: 'relative',
          transition: 'all 0.4s ease',
          ...(highlight && {
            backgroundColor: 'rgba(248, 166, 0, 0.08)',
            boxShadow: '0 0 30px rgba(248, 166, 0, 0.3)',
            border: '1px solid rgba(248, 166, 0, 0.4)',
          }),
        }}
      >
        {/* Animated MUI Icon Pointer */}
        <Fade in={highlight} timeout={600}>
          <Box
            sx={{
              position: 'absolute',
              top: isMobile ? '-60px' : '-70px',
              left: isMobile ? '50%' : '50%',
              transform: isMobile ? 'translateX(-50%)' : 'translateX(-50%)',
              zIndex: 10,
              display: highlight ? 'flex' : 'none',
              flexDirection: 'column',
              alignItems: 'center',
              animation: highlight ? 'pointDown 2s ease-in-out infinite' : 'none',
              '@keyframes pointDown': {
                '0%': {
                  transform: isMobile ? 'translateX(-50%) translateY(0)' : 'translateX(-50%) translateY(0)',
                  opacity: 1,
                },
                '50%': {
                  transform: isMobile ? 'translateX(-50%) translateY(10px)' : 'translateX(-50%) translateY(15px)',
                  opacity: 0.8,
                },
                '100%': {
                  transform: isMobile ? 'translateX(-50%) translateY(0)' : 'translateX(-50%) translateY(0)',
                  opacity: 1,
                },
              },
            }}
          >
            <HomeIcon
              sx={{
                fontSize: isMobile ? '60px' : '80px',
                color: '#f8a600',
                filter: 'drop-shadow(0 4px 12px rgba(248, 166, 0, 0.8))',
                animation: 'iconPulse 1.5s ease-in-out infinite',
                '@keyframes iconPulse': {
                  '0%, 100%': {
                    transform: 'scale(1)',
                  },
                  '50%': {
                    transform: 'scale(1.1)',
                  },
                },
              }}
            />
            <Typography
              sx={{
                color: '#f8a600',
                fontSize: '14px',
                fontWeight: 600,
                mt: 0.5,
                textShadow: '0 2px 8px rgba(248, 166, 0, 0.6)',
              }}
            >
              Contact Here ↓
            </Typography>
          </Box>
        </Fade>

        {/* Subtle Background Accent Line */}
        {highlight && (
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '4px',
              height: '100%',
              backgroundColor: '#f8a600',
              borderRadius: '4px',
              animation: 'slideDown 0.6s ease-out',
              '@keyframes slideDown': {
                from: {
                  height: '0%',
                  opacity: 0,
                },
                to: {
                  height: '100%',
                  opacity: 1,
                },
              },
            }}
          />
        )}

        <Typography
          variant="h6"
          sx={{
            mb: 1,
            fontWeight: 600,
            color: highlight ? '#f8a600' : '#FFFFFF',
            transition: 'color 0.4s ease',
            position: 'relative',
          }}
        >
          Contact Details
          {highlight && (
            <Box
              component="span"
              sx={{
                display: 'inline-block',
                ml: 1,
                animation: 'pulse 1.5s ease-in-out infinite',
                '@keyframes pulse': {
                  '0%, 100%': { opacity: 1 },
                  '50%': { opacity: 0.5 },
                },
              }}
            >
              ✨
            </Box>
          )}
        </Typography>

        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
          <li style={{ marginBottom: 10 }}>
            <Stack direction="row" alignItems="center" justifyContent={isMobile ? 'center' : 'flex-start'}>
              <Box component="img" src={addressIcon} alt="address" sx={{ width: 16, height: 16, mr: 1 }} />
              <Typography sx={{ fontSize: 17, fontWeight: 400, color: '#CBD5E1' }}>
                Kukatpally, Hyderabad, Telangana - 72
              </Typography>
            </Stack>
          </li>
          <li style={{ marginBottom: 10 }}>
            <Link href="#" underline="none" sx={{ color: '#FF9900', fontWeight: 500, fontSize: 17 }}>
              View on Google map
            </Link>
          </li>
          <li>
            <Stack direction="row" alignItems="center" justifyContent={isMobile ? 'center' : 'flex-start'}>
              <Box
                component="img"
                src={contactIcon}
                alt="contact"
                sx={{ width: 18, height: 57, mr: 1.5 }}
              />
              <Box>
                <Typography sx={{ fontSize: 17, fontWeight: 400, color: '#CBD5E1' }}>
                  <Link
                    href="mailto:propertydealstalk@gmail.com"
                    underline="none"
                    sx={{ color: '#CBD5E1', '&:hover': { color: '#FF9900' } }}
                  >
                    propertydealstalk@gmail.com
                  </Link>
                </Typography>
                <Typography sx={{ fontSize: 17, fontWeight: 400, color: '#CBD5E1' }}>
                  <Link
                    href="tel:+919346799389"
                    underline="none"
                    sx={{ color: '#CBD5E1', '&:hover': { color: '#FF9900' } }}
                  >
                    +91 93467 99389
                  </Link>
                </Typography>
                <Typography sx={{ fontSize: 17, fontWeight: 400, color: '#CBD5E1' }}>
                  <Link
                    href="tel:+917780251777"
                    underline="none"
                    sx={{ color: '#CBD5E1', '&:hover': { color: '#FF9900' } }}
                  >
                    +91 77802 51777
                  </Link>
                </Typography>
              </Box>
            </Stack>
          </li>
        </ul>
      </Box>
    </Box>
  );
};

export default Footer;
